<div class="typing-text-container" style="--gap: {{ncGap}}px;">
    {{ displayedText }}
</div>